import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";
import { Close } from "@mui/icons-material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

export default function SaveOutboundNumberDialog(props) {
  const posClickCallback = () => {
    AnalyticsService.pushEvent("Button Clicked", {
      type: "Save Outbound Number",
      page: window.location.pathname,
    });
    const jscode =
      "var event = new CustomEvent('outboundNumberUpdated', { detail: { updatedStatus: '%1$s' } }); window.dispatchEvent(event);";
    const contactName = "AgroStar Saathi Relationship Manager";
    const outboundNumber =
      localStorage.getItem(`outboundCallingNumber`) &&
      localStorage.getItem(`outboundCallingNumber`) !== undefined
        ? localStorage.getItem(`outboundCallingNumber`)
        : "";
    const newOutboundNumber =
      localStorage.getItem("newOutboundCallingNumber") &&
      localStorage.getItem("newOutboundCallingNumber") !== undefined
        ? localStorage.getItem("newOutboundCallingNumber")
        : null;
    if (newOutboundNumber !== null) {
      AndroidService.saveOutboundNumberNudge(
        contactName,
        newOutboundNumber,
        outboundNumber,
        jscode
      );
    } else {
      AndroidService.saveOutboundNumberNudge(
        contactName,
        outboundNumber,
        newOutboundNumber,
        jscode
      );
    }
    props.handleClose();
  };

  const onCloseCallback = () => {
    if (
      localStorage.getItem("saveOutboundNumberDialogActualShownCount") &&
      localStorage.getItem("saveOutboundNumberDialogActualShownCount") !==
        undefined
    ) {
      localStorage.setItem(
        "saveOutboundNumberDialogActualShownCount",
        parseInt(
          localStorage.getItem("saveOutboundNumberDialogActualShownCount")
        ) + 1
      );
    } else {
      localStorage.setItem("saveOutboundNumberDialogActualShownCount", 1);
    }
    sessionStorage.setItem("saveoutboundNumberDialogShown", true);
    AnalyticsService.pushEvent("Save Outbound Number Dialog Dismissed", {
      page: window.location.pathname,
    });
    props.handleClose();
  };

  return (
    <Dialog
      open={props.shouldShow}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
        } else {
          onCloseCallback();
        }
      }}
      PaperProps={{ sx: { borderRadius: "20px" } }}
    >
      <DialogContent sx={{ padding: "24px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <PersonAddIcon sx={{ flex: "1", height: "4rem" }} />
            <Close
              style={{ alignSelf: "flex-start", color: `#CACACA` }}
              onClick={() => onCloseCallback()}
            />
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              marginTop: "6px",
              textAlign: "center",
            }}
          >
            {getTitleBasedOnSource()}
          </Typography>
          <Typography
            sx={{ fontSize: "12px", marginTop: "6px", textAlign: "center" }}
          >
            {getSubtitleBasedOnSource()}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => posClickCallback()}
            sx={{ marginTop: "10px" }}
          >
            Add to contacts
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );

  function getTitleBasedOnSource() {
    const source = localStorage.getItem("source");
    switch (source) {
      case "B2BMH":
        return "आपल्या साथी रिलेशनशिप मॅनेजरचा नंबर सेव्ह करा आणि डील्सबद्दल सर्वात आधी माहिती मिळवा!";
      case "B2BGJ":
        return "તમારા સાથી રિલેશનશીપ મેનેજરનો નંબર સેવ કરો અને ડીલ્સ વિશે સૌથી પહેલા જાણો!";
      case "B2BKA":
        return " ನಿಮ್ಮ ಸಹ ರಿಲೇಶನ್‌ಶಿಪ್ ಮ್ಯಾನೇಜರ್‌ನ ಸಂಖ್ಯೆಯನ್ನು ಸೇವ್ ಮಾಡಿ ಮತ್ತು ಡೀಲುಗಳ ಬಗ್ಗೆ ಮೊದಲು ತಿಳಿದುಕೊಳ್ಳಿ!";
      case "B2BTS":
        return "మీ సహ రిలేషన్‌షిప్ మేనేజర్ నంబర్ సేవ్ చేసుకోండి మరియు ఆఫర్ల గురించి ముందుగానే తెలుసుకోండి!";
      default:
        return "अपने साथी रिलेशनशिप मैनेजर का नंबर सेव करें और डील्स के बारे में सबसे पहले जानें!";
    }
  }

  function getSubtitleBasedOnSource() {
    const source = localStorage.getItem("source");
    switch (source) {
      case "B2BMH":
        return `"Add to Contact" वर क्लिक करून संपर्क सेव करण्याची परवानगी द्या.`;
      case "B2BGJ":
        return `"Add to Contact" પર ક્લિક કરીને સંપર્ક સેવ કરવાની પરવાનગી આપો.`;
      case "B2BKA":
        return `"Add to Contact" ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ ಸಂಪರ್ಕವನ್ನು ಸಂರಕ್ಷಿಸಲು ಅನುಮತಿ ನೀಡಿ.`;
      case "B2BTS":
        return `"Add to Contact" పై క్లిక్ చేసి సంప్రదింపు సేవ్ చేయడానికి అనుమతి ఇవ్వండి."`;
      default:
        return `“Add to Contact” पर क्लिक करके कॉन्टैक्ट सेव करने की परमिशन दे`;
    }
  }
}
